function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import View from "../../src/Core/View";
import GeometryLayer from "../../src/Layer/GeometryLayer";
import { MAIN_LOOP_EVENTS } from "../../src/Core/MainLoop";
import ObjectRemovalHelper from "../../src/Process/ObjectRemovalHelper";
import TileObjectChart from "./charts/TileObjectChart";
import TileVisibilityChart from "./charts/TileVisibilityChart";
import GeometryDebug from "./GeometryDebug";
import Debug from "./Debug";
import OBBHelper from "./OBBHelper";

function applyToNodeFirstMaterial(view, root, layer, cb) {
  root.traverse(function (object) {
    if (object.material && object.layer === layer) {
      cb(object.material);
    }
  });
  view.notifyChange();
}

var selectedNode;
/**
 * Select tile
 *
 * @param      {View} view
 * @param      {Object} mouseOrEvt - mouse position in window coordinates (0, 0 = top-left)
 * or MouseEvent or TouchEvent.
 * @param      {boolean}  [showInfo=true] Show tile information in console.
 * @return     {TileMesh} Selected tile.
 */

function selectTileAt(view, mouseOrEvt) {
  var showInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (selectedNode) {
    selectedNode.material.overlayAlpha = 0;
    selectedNode.material.showOutline = view.tileLayer.showOutline;
    view.notifyChange(selectedNode);
  }

  var picked = view.tileLayer.pickObjectsAt(view, mouseOrEvt);
  selectedNode = picked.length ? picked[0].object : undefined;

  if (selectedNode) {
    if (showInfo) {
      // eslint-disable-next-line no-console
      console.info(selectedNode);
    }

    selectedNode.material.overlayAlpha = 0.5;
    selectedNode.material.showOutline = true;
    view.notifyChange(selectedNode);
  }

  return selectedNode;
}

export default function createTileDebugUI(datDebugTool, view, layer, debugInstance) {
  var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (!view.isDebugMode && !force) {
    return;
  }

  debugInstance = debugInstance || new Debug(view, datDebugTool);
  layer = layer || view.tileLayer;
  var gui = GeometryDebug.createGeometryDebugUI(datDebugTool, view, layer);
  var objectChardId = "".concat(layer.id, "-nb-objects");
  var canvasObjectChardId = debugInstance.createChartContainer(objectChardId);
  var visibleChardId = "".concat(layer.id, "-nb-visible");
  var canvasVisibleChardId = debugInstance.createChartContainer(visibleChardId);
  debugInstance.charts.push(new TileObjectChart(canvasObjectChardId.getContext('2d'), layer));
  debugInstance.charts.push(new TileVisibilityChart(canvasVisibleChardId.getContext('2d'), layer));
  layer.showOutline = false;
  layer.wireframe = false;
  var state = {
    objectChart: true,
    visibilityChart: true,
    sseHelper: false
  }; // tiles outline

  gui.add(layer, 'showOutline').name('Show tiles').onChange(function (newValue) {
    layer.showOutline = newValue;
    applyToNodeFirstMaterial(view, layer.object3d, layer, function (material) {
      material.showOutline = newValue;
    });
  }); // tiles wireframe

  gui.add(layer, 'wireframe').name('Wireframe').onChange(function () {
    view.notifyChange(layer);
  }); // TileObjectChart visibility

  gui.add(state, 'objectChart').name('Object chart').onChange(function (newValue) {
    if (newValue) {
      document.getElementById(objectChardId).parentNode.style.display = 'block';
    } else {
      document.getElementById(objectChardId).parentNode.style.display = 'none';
    }

    debugInstance.updateChartDivSize();
    debugInstance.charts.forEach(function (c) {
      return c.update();
    });
  }); // TileVisibilityChart visibility

  gui.add(state, 'visibilityChart').name('Visibility chart').onChange(function (newValue) {
    if (newValue) {
      document.getElementById(visibleChardId).parentNode.style.display = 'block';
    } else {
      document.getElementById(visibleChardId).parentNode.style.display = 'none';
    }

    debugInstance.updateChartDivSize();
    debugInstance.charts.forEach(function (c) {
      return c.update();
    });
  }); // Bounding box control

  var obb_layer_id = "".concat(layer.id, "_obb_debug");
  var sb_layer_id = "".concat(layer.id, "_sb_debug");
  var geometrySphere = new THREE.SphereGeometry(1, 16, 16);

  function debugIdUpdate(context, layer, node) {
    var enabled = context.camera.camera3D.layers.test({
      mask: 1 << layer.threejsLayer
    });

    if (!node.parent || !enabled) {
      ObjectRemovalHelper.removeChildrenAndCleanupRecursively(layer, node);
      return;
    }

    var helper = node.children.filter(function (n) {
      return n.layer && n.layer.id == layer.id;
    })[0];

    if (node.material && node.material.visible) {
      if (!helper) {
        // add the ability to hide all the debug obj for one layer at once
        var l = context.view.getLayerById(layer.id);
        var l3js = l.threejsLayer;

        if (layer.id == obb_layer_id) {
          helper = new OBBHelper(node.obb, "id:".concat(node.id));

          if (helper.children[0]) {
            helper.children[0].layers.set(l3js);
          }
        } else if (layer.id == sb_layer_id) {
          var color = new THREE.Color(Math.random(), Math.random(), Math.random());
          var material = new THREE.MeshBasicMaterial({
            color: color.getHex(),
            wireframe: true
          });
          helper = new THREE.Mesh(geometrySphere, material);
          helper.position.copy(node.boundingSphere.center);
          helper.scale.multiplyScalar(node.boundingSphere.radius);
        }

        helper.layers.set(l3js);
        helper.layer = layer;
        node.add(helper);
        helper.updateMatrixWorld(true); // if we don't do that, our OBBHelper will never get removed,
        // because once a node is invisible, children are not removed
        // any more

        var hiddenHandler = node.material.addEventListener('hidden', function () {
          node.material.removeEventListener(hiddenHandler);
          var i = node.children.length;

          while (i--) {
            var c = node.children[i];

            if (c.layer === sb_layer_id) {
              if (c.dispose) {
                c.dispose();
              } else if (Array.isArray(c.material)) {
                var _iterator = _createForOfIteratorHelper(c.material),
                    _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var _material = _step.value;

                    _material.dispose();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              } else {
                c.material.dispose();
              }

              node.children.splice(i, 1);
            }
          }
        });
      }

      if (layer.id == sb_layer_id) {
        helper.position.copy(node.boundingSphere.center);
        helper.scale.set(1, 1, 1).multiplyScalar(node.boundingSphere.radius);
      }

      helper.updateMatrixWorld(true);
      helper.visible = true;
    } else if (helper) {
      helper.visible = false;
    }
  }

  var obbLayer = new GeometryLayer(obb_layer_id, new THREE.Object3D(), {
    update: debugIdUpdate,
    visible: false,
    cacheLifeTime: Infinity,
    source: false
  });
  View.prototype.addLayer.call(view, obbLayer, layer).then(function (l) {
    gui.add(l, 'visible').name('Bounding boxes').onChange(function () {
      view.notifyChange(l);
    });
  });
  var sbLayer = new GeometryLayer(sb_layer_id, new THREE.Object3D(), {
    update: debugIdUpdate,
    visible: false,
    cacheLifeTime: Infinity,
    source: false
  });
  View.prototype.addLayer.call(view, sbLayer, layer).then(function (l) {
    gui.add(l, 'visible').name('Bounding Spheres').onChange(function () {
      view.notifyChange(l);
    });
  });
  var viewerDiv = document.getElementById('viewerDiv');
  var circle = document.createElement('span');
  circle.className = 'circleBase';
  viewerDiv.appendChild(circle);
  var centerNode = new THREE.Vector3();
  var actualNode;

  var animationFrameRequester = function () {
    TWEEN.update();
    view.notifyChange();
  };

  var removeAnimationRequester = function () {
    TWEEN.removeAll();

    if (view._frameRequesters[MAIN_LOOP_EVENTS.BEFORE_RENDER].includes(animationFrameRequester)) {
      view.removeFrameRequester(MAIN_LOOP_EVENTS.BEFORE_RENDER, animationFrameRequester);
    }
  };

  function picking(event) {
    var selectNode = selectTileAt(view, event, false);

    if (selectNode) {
      circle.style.display = 'table-cell';
      centerNode.copy(selectNode.boundingSphere.center).applyMatrix4(selectNode.matrixWorld);
      var project = centerNode.project(view.camera.camera3D);
      var coords = view.normalizedToViewCoords(project);
      var size = selectNode.screenSize;

      if (actualNode != selectNode) {
        var actualSize = Number(circle.style.width.replace('px', ''));
        actualNode = selectNode;
        removeAnimationRequester();
        new TWEEN.Tween({
          size: actualSize
        }).to({
          size: size
        }, 500).easing(TWEEN.Easing.Sinusoidal.In).easing(TWEEN.Easing.Exponential.Out).onUpdate(function (object) {
          circle.style['line-height'] = "".concat(object.size, "px");
          circle.style.width = "".concat(object.size, "px");
          circle.style.height = "".concat(object.size, "px");
          circle.innerHTML = "".concat(Math.floor(object.size), " px");
          circle.style.left = "".concat(coords.x - object.size * 0.5, "px");
          circle.style.top = "".concat(coords.y - object.size * 0.5, "px");
        }).onComplete(removeAnimationRequester).start();
        view.addFrameRequester(MAIN_LOOP_EVENTS.BEFORE_RENDER, animationFrameRequester);
      }
    } else {
      circle.style.display = 'none';
    }
  }

  gui.add(state, 'sseHelper').name('Sse helper').onChange(function (v) {
    if (v) {
      window.addEventListener('mousemove', picking, false);
    } else {
      circle.style.display = 'none';
      removeAnimationRequester();
      window.removeEventListener('mousemove', picking);
    }
  });
  var currKey = null;
  window.addEventListener('mousedown', function (event) {
    if (currKey == 83) {
      selectTileAt(view, event);
    }
  });
  window.addEventListener('keydown', function (event) {
    currKey = event.which;
  });
  window.addEventListener('keyup', function () {
    currKey = null;
  });
}